import { useTranslation } from "react-i18next";
import type { PlatformTypeName } from "@multi-chat/shared";
import { ChannelIdentityBadge } from "../../components/channel/ChannelIdentityBadge.js";
import { cn } from "../../lib/utils.js";

const PLATFORMS = ["whatsapp", "facebook", "instagram"] as const;

export type SuperAdminPlatformId = (typeof PLATFORMS)[number];

const PLATFORM_TYPE: Record<SuperAdminPlatformId, PlatformTypeName> = {
  whatsapp: "WHATSAPP",
  facebook: "FACEBOOK",
  instagram: "INSTAGRAM",
};

export function PlatformEntitlementMark({
  platform,
  enabled,
  labeled = false,
}: {
  platform: SuperAdminPlatformId;
  enabled: boolean;
  labeled?: boolean;
}): React.JSX.Element {
  const { t } = useTranslation();
  const name = t(`channels.platforms.${platform}`);
  const state = enabled ? t("superAdmin.platforms.enabled") : t("superAdmin.platforms.disabled");
  const label = `${name} ${state}`;

  return (
    <span
      className={cn("inline-flex items-center gap-2", labeled && "min-w-0")}
      title={label}
      aria-label={label}
      data-platform={platform}
      data-entitlement={enabled ? "enabled" : "disabled"}
    >
      <ChannelIdentityBadge
        platformType={PLATFORM_TYPE[platform]}
        size={labeled ? "filter" : "table"}
        muted={!enabled}
      />
      {labeled ? (
        <span className="min-w-0">
          <span className="block text-sm font-medium text-foreground">{name}</span>
          <span className={cn("block text-[0.75rem]", enabled ? "text-foreground" : "text-muted")}>{state}</span>
        </span>
      ) : null}
    </span>
  );
}
